import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import RenderSingle from '../components/Pages/RenderSingle';
import Related from '../components/Pages/Related';

class SingleActueel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showRelated: false,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.timeOut = setTimeout(() => {
            this.setState({ showRelated: true });
        }, 500);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        if (willMount) {
            this.props.fetchSinglePost('posts', this.props.match.params.slug);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.posts.fetched) {
            document.title = `${nextProps.posts.posts[0].title.rendered} - Friends for Brands`;
        }
    }

    getRelated(post) {
        if (post) {
            if (post.acf.related) {
                return <Related related={post.acf.related} />;
            } else {
                return '';
            }
        }
    }

    render() {
        return (
            <div id="actueel" className="actueel single">
                <Header />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <Link to="/behind-the-scenes" className="nav-btn">
                                <i className="icon icon-arrow_right" />
                                <span>Behind the scenes</span>
                            </Link>
                            <Loader
                                loaded={
                                    this.props.posts.fetched ||
                                    this.props.posts.failed
                                }
                            />
                            {this.props.posts.fetched &&
                            this.props.posts.posts.length > 0 ? (
                                <div className="fadeIn">
                                    <RenderSingle posts={this.props.posts} />
                                    {this.state.showRelated && (
                                        <div className="fadeIn">
                                            {this.getRelated(
                                                this.props.posts.posts[0]
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                ''
                            )}
                            {this.props.posts.fetched &&
                            this.props.posts.posts.length === 0 ? (
                                <h2 className="fadeIn">
                                    :(!
                                    <br />
                                    Er is iets misgegaan. Probeer het later
                                    opnieuw.
                                    <br />
                                    <br />
                                </h2>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SingleActueel)
);



// WEBPACK FOOTER //
// ./src/containers/SingleActueel.jsx